<template>
  <div v-show="panelShow">
    <SelectServer ref="SelectServer" v-on:selectServerComplete="selectServerComplete"></SelectServer>
    <Col span="24" :style="{padding: '5px'}">
      <Card shadow class="monitor-tmp-card home-card" id="monitor-overview-card">
        <div slot="title">
          <Icon type="md-pulse" />
          <b> 监控概览</b>
          <!--<div style="float: right">-->
            <!--<Tooltip content="自动刷新" placement="bottom">-->
              <!--<i-switch v-model="autoRefresh" style="margin-right: 15px" size="small" @on-change="controlMonitorTimer">-->
                <!--<span slot="open"></span>-->
                <!--<span slot="close"></span>-->
              <!--</i-switch>-->
            <!--</Tooltip>-->
            <!--<Tooltip content="刷新" placement="bottom">-->
              <!--<a v-on:click="" style="margin-right: 15px" v-show="">-->
                <!--<Icon type="md-refresh" size="18" />-->
              <!--</a>-->
            <!--</Tooltip>-->
          <!--</div>-->
        </div>
        <div id="monitor-overview" style="padding: unset">
          <Row style="padding: 5px; height: 42px" id="overview-form">
            <Form inline :label-width="40">
              <FormItem label="刷新">
                <Select v-model="interval" style="width: 60px;" @on-change="controlMonitorTimer">
                  <Option :value="30">30s</Option>
                  <Option :value="60">60s</Option>
                </Select>
              </FormItem>
              <FormItem label="主机">
                <Button type="default" @click="openSelectServerModal" class="select-server-btn">
                  <span v-if="hostname">{{ hostname }}</span>
                  <span v-else>选择主机</span>
                </Button>
              </FormItem>
            </Form>
          </Row>
          <Row style="padding: 5px;">
            <div style="display: block; text-align: center; height: 30px" :style="{backgroundColor: monitorBlockBackgroundColor}">
              <span style="line-height: 30px; font-size: 18px; color: #fff">{{ hostname }}</span>
            </div>
          </Row>
          <div class="ivu-div">
            <Row>
              <Col :xs="24" :sm="12" :md="4" :lg="4" style="padding: 5px; minWidth: 130px; height: 200px;">
                <Row>
                  <div class="alarms" style="background-color: rgba(110, 208, 224, 0.5); height: 95px; margin-bottom: 5px; text-align: center;">
                    <div style="line-height: 25px">
                      <span style="font-weight: bold; color: #ffffff; font-size: 14px;">近7日告警</span>
                    </div>
                    <div style="font-weight: bold; color: #ffffff; margin: 0 auto" :style="{ fontSize: recent_count === 'nodata' ? '25px' : '40px' }">{{ recent_count }}</div>
                  </div>
                </Row>
                <Row>
                  <div class="alarmimg" style="background-color: rgba(237, 64, 20, 0.5); height: 95px; margin-top: 5px; text-align: center;">
                    <div style="line-height: 25px">
                      <span style="font-weight: bold; color: #ffffff; font-size: 14px;">正在告警</span>
                    </div>
                    <div style="font-weight: bold; color: #ffffff; margin: 0 auto" :style="{ fontSize: problem_count === 'nodata' ? '25px' : '40px' }">{{ problem_count }}</div>
                  </div>
                </Row>
              </Col>
              <Col :xs="24" :sm="12" :md="8" :lg="4" style="padding: 5px;">
                <Row :style="{backgroundColor: monitorBlockBackgroundColor}">
                  <div id="cpu_usage_gauge" style="height: 200px;width:100%;" v-if="cpuUsageGaugeShow"></div>
                  <noData200H title="CPU使用率" v-else></noData200H>
                </Row>
              </Col>
              <Col :xs="24" :sm="12" :md="8" :lg="4" style="padding: 5px;">
                <Row :style="{backgroundColor: monitorBlockBackgroundColor}">
                  <div id="memory_usage_gauge" style="height: 200px;width:100%;" v-if="memoryUsageGaugeShow"></div>
                  <noData200H title="内存使用率" v-else></noData200H>
                </Row>
              </Col>
              <Col :xs="24" :sm="12" :md="8" :lg="4" style="padding: 5px;">
                <Row :style="{backgroundColor: monitorBlockBackgroundColor}">
                  <div id="disk_usage_gauge" style="height: 200px;
  width:100%;
" v-if="diskUsageGaugeShow"></div>
                  <noData200H title="磁盘使用率" v-else></noData200H>
                </Row>
              </Col>
              <Col :xs="12" :sm="12" :md="8" :lg="4" style="padding: 5px;">
                <Row>
                  <div style="height: 95px; margin-bottom: 5px; text-align: center;" :style="{backgroundColor: monitorBlockBackgroundColor}">
                    <div style="line-height: 30px">
                      <span style="font-weight: bold; color: #ffffff; font-size: 14px;">网络 In</span>
                    </div>
                    <div style="font-weight: bold; color: #ffffff; margin: 0 auto" :style="{ fontSize: netInBytes === 'nodata' ? '25px' : '30px' }">{{ netInBytes }}</div>
                  </div>
                </Row>
                <Row>
                  <div style="height: 95px; margin-top: 5px; padding-bottom: 5px; text-align: center;" :style="{backgroundColor: monitorBlockBackgroundColor}">
                    <div style="line-height: 30px">
                      <span style="font-weight: bold; color: #ffffff; font-size: 14px;">网络 Out</span>
                    </div>
                    <div style="font-weight: bold; color: #ffffff; margin: 0 auto" :style="{ fontSize: netOutBytes === 'nodata' ? '25px' : '30px' }">{{ netOutBytes }}</div>
                  </div>
                </Row>
              </Col>
              <Col :xs="12" :sm="12" :md="8" :lg="4" style="padding: 5px;">
                <Row>
                  <div style="height: 95px; margin-bottom: 5px; text-align: center;" :style="{backgroundColor: monitorBlockBackgroundColor}">
                    <div style="line-height: 30px">
                      <span style="font-weight: bold; color: #ffffff; font-size: 14px;">磁盘 Read</span>
                    </div>
                    <div style="font-weight: bold; color: #ffffff; margin: 0 auto" :style="{ fontSize: diskReadBytes === 'nodata' ? '25px' : '30px' }">{{ diskReadBytes }}</div>
                  </div>
                </Row>
                <Row>
                  <div style="height: 95px; margin-top: 5px; padding-bottom: 5px; text-align: center;" :style="{backgroundColor: monitorBlockBackgroundColor}">
                    <div style="line-height: 30px">
                      <span style="font-weight: bold; color: #ffffff; font-size: 14px;">磁盘 Write</span>
                    </div>
                    <div style="font-weight: bold; color: #ffffff; margin: 0 auto" :style="{ fontSize: diskWriteBytes === 'nodata' ? '25px' : '30px' }">{{ diskWriteBytes }}</div>
                  </div>
                </Row>
              </Col>
            </Row>
            <Row type="flex">
              <Col :xs="24" :sm="24" :md="24" :lg="12" style="padding: 5px">
                <Row v-if="cpuUsageLineShow" :style="{backgroundColor: monitorBlockBackgroundColor}">
                  <Col :lg="24" class-name="ivu-col-span-xxl-14">
                    <div id="cpu_usage_line" :style="getChartHeight(12)"></div>
                  </Col>
                  <Col :lg="24" class-name="ivu-col-span-xxl-10">
                    <Legend class="charts-legend" valueWidth="60px" unit="%" :option="cpuUsageLineAreaOptionsIntact" tableFontSize="13px"></Legend>
                  </Col>
                </Row>
                <noData300H title="CPU" v-else></noData300H>
              </Col>
              <Col :xs="24" :sm="24" :md="24" :lg="12" style="padding: 5px;">
                <Row v-if="memoryUsageLineShow" :style="{backgroundColor: monitorBlockBackgroundColor}">
                  <Col :lg="24" class-name="ivu-col-span-xxl-13">
                    <div id="memory_usage_line" :style="getChartHeight(12)"></div>
                  </Col>
                  <Col :lg="24" class-name="ivu-col-span-xxl-11">
                    <Legend class="charts-legend" valueWidth="60px" unit="%" :option="memoryUsageLineAreaOptionsIntact" tableFontSize="13px"></Legend>
                  </Col>
                </Row>
                <noData300H title="内存" v-else></noData300H>
              </Col>
              <Col :xs="24" :sm="24" :md="24" :lg="12" style="padding: 5px">
                <Row v-if="loadLineShow" :style="{backgroundColor: monitorBlockBackgroundColor}">
                  <Col :lg="24" class-name="ivu-col-span-xxl-16">
                    <div id="load_line" :style="getChartHeight(12)"></div>
                  </Col>
                  <Col :lg="24" class-name="ivu-col-span-xxl-8">
                    <Legend class="charts-legend" valueWidth="60px" :option="loadLineAreaOptionsIntact" tableFontSize="13px"></Legend>
                  </Col>
                </Row>
                <noData300H title="平均负载" v-else></noData300H>
              </Col>
              <Col :xs="24" :sm="24" :md="24" :lg="12" style="padding: 5px">
                <Row v-if="ssLineShow" :style="{backgroundColor: monitorBlockBackgroundColor}">
                  <Col :lg="24" class-name="ivu-col-span-xxl-14">
                    <div id="ss_line" :style="getChartHeight(12)"></div>
                  </Col>
                  <Col :lg="24" class-name="ivu-col-span-xxl-10">
                    <Legend class="charts-legend" valueWidth="60px" :option="ssLineAreaOptionsIntact" tableFontSize="13px"></Legend>
                  </Col>
                </Row>
                <noData300H title="Socket Statistics" v-else></noData300H>
              </Col>
              <Col :xs="24" :sm="24" :md="24" :lg="12" style="padding: 5px">
                <Row v-if="IOPSLineShow" :style="{backgroundColor: monitorBlockBackgroundColor}">
                  <Col :lg="24" class-name="ivu-col-span-xxl-14">
                    <div id="disk_iops_line" :style="getChartHeight(12)"></div>
                  </Col>
                  <Col :lg="24" class-name="ivu-col-span-xxl-10">
                    <Legend class="charts-legend" valueWidth="60px" :option="IOPSLineAreaOptionsIntact" tableFontSize="13px"></Legend>
                  </Col>
                </Row>
                <noData300H title="IOPS" v-else></noData300H>
              </Col>
              <Col :xs="24" :sm="24" :md="24" :lg="12" style="padding: 5px;">
                <Row :style="{backgroundColor: monitorBlockBackgroundColor}">
                  <div id="disk_part_bar" :style="getChartHeight(12)" v-if="diskPartBarShow"></div>
                  <noData300H title="磁盘分区使用率" v-else></noData300H>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </Card>
    </Col>
  </div>
</template>

<script>
import Legend from '../../monitor/components/legend'
import { getEndpointMonitorData, getBaseMonitorOne, getAlarmOverView, getDiskPartUseMonitorData } from '@/api/monitor'
import echarts from '../../../view/monitor/components/echarts-use.js'
import SelectServer from '@/view/ops-center/select-server'
import noData200H from '@/components/nodata/nodata_200_h'
import noData300H from '@/components/nodata/nodata_300_h'
import { valueTranUnit } from '@/libs/tools'

export default {
  name: 'monitor-overview',
  components: {
    Legend,
    SelectServer,
    noData200H,
    noData300H
  },
  props: {
    panelShow: {
      type: Boolean,
      default: true
    },
    defaultEndpoint: {
      type: String,
      default: ''
    }
  },
  watch: {
    panelShow () {
      if (this.panelShow) {
        this.hostname = this.defaultEndpoint
        this.getData()
        this.getCurrentData()
        this.getAlarmOver()
        this.getDiskPartUseData()
        this.controlMonitorTimer()
      }
    }
  },
  created: function () {
    if (this.panelShow) {
      this.hostname = this.defaultEndpoint
      this.getData()
      this.getCurrentData()
      this.getAlarmOver()
      this.getDiskPartUseData()
      this.controlMonitorTimer()
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  data () {
    return {
      autoRefresh: true,
      monitorTheme: 'darkPro',
      interval: 30,
      server: '',
      timer: null,
      monitorBlockBackgroundColor: '#1E1C1D',
      hostname: 'ubuntu',
      recent_count: 'nodata',
      problem_count: 'nodata',
      netInBytes: 'nodata',
      netOutBytes: 'nodata',
      diskReadBytes: 'nodata',
      diskWriteBytes: 'nodata',
      memoryUsageGaugeShow: false,
      cpuUsageGaugeShow: false,
      diskUsageGaugeShow: false,
      cpuUsageLineAreaOptionsIntact: null,
      cpuUsageLineShow: false,
      memoryUsageLineAreaOptionsIntact: null,
      memoryUsageLineShow: false,
      IOPSLineAreaOptionsIntact: null,
      IOPSLineShow: false,
      loadLineAreaOptionsIntact: null,
      loadLineShow: false,
      option: {
        title: {
          text: '',
          left: 'center',
          y: 6,
          textStyle: {
            fontSize: 15
          }
        },
        grid: {
          x: 40,
          x2: 40,
          left: 60,
          top: 40,
          bottom: 20
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let str = '<div>' + params[0].axisValueLabel + '</div>'
            for (let i = 0; i < params.length; i++) {
              let value = params[i].data[1]
              let reValue = valueTranUnit(value, 1, '%')
              str += '<div class="circle_tooltip" style="background-color: ' + params[i].color + '"></div>' +
                '<span>' + params[i].seriesName + '</span> : <span>' + (value !== null ? reValue : '无数据') + '</span><br/>'
            }
            return str
          }
        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: true
          },
          axisLabel: {
            formatter: function (value, index) {
              let date = new Date(value)
              let texts = [(date.getHours()), date.getMinutes()]

              return texts.join(':')
            }
          }
        },
        yAxis: {
          min: 0,
          max: 100,
          type: 'value',
          splitLine: {
            show: true
          },
          axisLabel: {
            formatter: function (value) {
              return valueTranUnit(value, 0, '%')
            }
          }
        },
        series: []
      },
      gaugeOption: {
        tooltip: {
          formatter: '{a} <br/>{b}: {c}%'
        },
        axisTick: {
          show: true,
          splitNumber: 5,
          length: 8,
          lineStyle: {
            color: '#eee',
            opacity: 1,
            width: 1,
            type: 'solid',
            shadowBlur: 10,
            shadowColor: '#fff'
          }
        },
        series: [
          {
            name: '',
            type: 'gauge',
            min: 0,
            max: 100,
            splitNumber: 10,
            radius: '90%',
            axisLine: {
              lineStyle: {
                color: [[0.6, 'lime'], [0.8, '#f4720b'], [1, '#ff1b02']],
                width: 1,
                shadowColor: '#fff',
                shadowBlur: 10
              }
            },
            axisLabel: {
              textStyle: {
                fontWeight: 'bolder',
                color: '#fff',
                shadowColor: '#fff',
                shadowBlur: 10
              }
            },
            axisTick: {
              length: 5,
              lineStyle: {
                color: 'auto',
                shadowColor: '#fff',
                shadowBlur: 10
              }
            },
            splitLine: {
              length: 8,
              lineStyle: {
                width: 3,
                color: '#fff',
                shadowColor: '#fff',
                shadowBlur: 10
              }
            },
            pointer: {
              shadowColor: '#fff',
              shadowBlur: 5,
              width: 3
            },
            title: {
              offsetCenter: [0, '90%'],
              textStyle: {
                fontWeight: 'bolder',
                fontSize: 15,
                color: '#fff',
                shadowColor: '#fff',
                shadowBlur: 10
              }
            },
            detail: {
              fontSize: 15,
              borderWidth: 1,
              borderColor: '#fff',
              shadowColor: '#fff',
              shadowBlur: 5,
              offsetCenter: [0, '50%'],
              textStyle: {
                fontWeight: 'bolder'
              }
            },
            data: []
          }
        ]
      },
      diskPartOption: {
        title: {
          text: '磁盘分区使用情况',
          left: 'center',
          y: 6,
          textStyle: {
            fontSize: 15
          }
        },
        grid: {
          x2: 40,
          top: '30%',
          left: 60,
          bottom: '15%'
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter: function (params) {
            let str = ''
            for (let i = 0; i < params.length; i++) {
              let value = params[i].data.value
              let name = params[i].name
              str += '<div><span>' + name + ': ' + value + '%' + '</span></div>'
            }
            return str
          }
        },
        xAxis: [{
          type: 'category',
          data: [],
          splitLine: {
            show: false
          },
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [{
          min: 0,
          max: 100,
          axisLabel: {
            formatter: '{value}%'
          },
          axisLine: {
            show: false
          }
        }],
        series: [{
          type: 'bar',
          data: [],
          barWidth: '10px',
          itemStyle: {
            normal: {
              color: function (d) {
                let color = [{
                  offset: 0,
                  color: '#10A7DB' // 0% 处的颜色
                }, {
                  offset: 0.8,
                  color: '#f4720b' // 80% 处的颜色
                }, {
                  offset: 1,
                  color: '#ff1b02' // 100% 处的颜色
                }]
                if (d.data.value < 60) {
                  color = [{
                    offset: 0,
                    color: '#10A7DB' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#66938C' // 100% 处的颜色
                  }]
                } else if (d.data.value < 80) {
                  color = [{
                    offset: 0,
                    color: '#10A7DB' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#f4720b' // 100% 处的颜色
                  }]
                }
                return new echarts.graphic.LinearGradient(0, 1, 0, 0, color, false)
              },
              barBorderRadius: [30, 30, 0, 0],
              shadowColor: 'rgba(0,255,225,1)',
              shadowBlur: 4
            }
          },
          label: {
            normal: {
              show: true,
              lineHeight: 30,
              width: 100,
              height: 30,
              backgroundColor: '#252453',
              borderRadius: 200,
              position: ['-12', '-60'],
              distance: 1,
              formatter: function (d) {
                return [
                  '    {d|●}',
                  ' {a|' + valueTranUnit(d.data.use, 1) + '}     \n',
                  '    {b|}'
                ].join(',')
              },
              rich: {
                d: {
                  color: '#3CDDCF'
                },
                a: {
                  color: '#fff',
                  align: 'center'
                },
                b: {
                  width: 1,
                  height: 30,
                  borderWidth: 1,
                  borderColor: '#234e6c',
                  align: 'left'
                }
              }
            }
          }
        }]
      },
      diskPartBarShow: false,
      ssLineShow: false,
      ssLineAreaOptionsIntact: null
    }
  },
  methods: {
    // 选择服务器完成回调
    selectServerComplete (server) {
      this.server = server
      if (Object.keys(server).length) {
        this.hostname = Object.keys(server)[0]
        this.getData()
        this.getCurrentData()
        this.getAlarmOver()
        this.getDiskPartUseData()
        this.controlMonitorTimer()
      }
    },
    // 打开服务器选择Modal
    openSelectServerModal () {
      this.$refs.SelectServer.openSelectServerModal({}, this.server, '', true)
    },
    // 获取图表高度
    getChartHeight (span) {
      let height = 200
      if (span === 8) {
        height = 250
      } else if (span === 12) {
        height = 300
      } else if (span === 24) {
        height = 350
      }
      return { 'height': height + 'px' }
    },
    // 获取监控数据
    getData () {
      if (!this.hostname) {
        return
      }
      let counterAndId = {
        'cpu.idle,cpu.busy,cpu.guest,cpu.iowait,cpu.irq,cpu.softirq,cpu.nice,cpu.steal,cpu.system,cpu.user': {
          id: 'cpu_usage_line',
          title: 'CPU',
          intactOptionKey: 'cpuUsageLineAreaOptionsIntact',
          show: 'cpuUsageLineShow',
          unit: '%'
        },
        'mem.memused.percent,mem.memfree.percent,mem.swapused.percent,mem.swapfree.percent': {
          id: 'memory_usage_line',
          title: '内存',
          intactOptionKey: 'memoryUsageLineAreaOptionsIntact',
          show: 'memoryUsageLineShow',
          unit: '%'
        },
        // 'df.statistics.used.percent': 'disk_usage_line',
        // 'net.if.in.bytes.total': 'in_net_bytes_line',
        // 'net.if.out.bytes.total': 'out_net_bytes_line',
        // 'net.if.in.packets.total': 'in_net_packets_line',
        // 'net.if.out.packets.total': 'out_net_packets_line',
        // 'disk.io.read_bytes.total': 'disk_io_read_bytes_line',
        // 'disk.io.write_bytes.total': 'disk_io_write_bytes_line',
        'load.1min,load.5min,load.15min': {
          id: 'load_line',
          title: '平均负载',
          intactOptionKey: 'loadLineAreaOptionsIntact',
          show: 'loadLineShow'
        },
        'ss.orphaned,ss.closed,ss.timewait,ss.slabinfo.timewait,ss.synrecv,ss.estab': {
          id: 'ss_line',
          title: 'Socket Statistics',
          intactOptionKey: 'ssLineAreaOptionsIntact',
          show: 'ssLineShow'
        },
        'disk.iops': {
          id: 'disk_iops_line',
          title: 'IOPS',
          intactOptionKey: 'IOPSLineAreaOptionsIntact',
          color: '#E88232',
          show: 'IOPSLineShow'
        }
      }
      for (let x in counterAndId) {
        let reqData = {
          'endpoints': [this.hostname],
          'counters': x.split(','),
          'angle': 'counter'
        }
        getEndpointMonitorData(reqData).then(res => {
          let generate = 0
          let result = res.data
          if (result.code === 200) {
            let data = result.data.series
            if (data.length > 0) {
              let dseries = []
              for (let v in data) {
                let dseriesData = []
                dseriesData = {
                  name: data[v].name,
                  type: 'line',
                  symbolSize: 0,
                  itemStyle: {
                    normal: {
                      lineStyle: {
                        width: 1
                      }
                    }
                  },
                  areaStyle: {
                    opacity: 0.2
                  },
                  data: data[v].data
                }
                generate = 1
                if (counterAndId[x].color) {
                  dseriesData.itemStyle.normal.color = counterAndId[x].color
                }
                dseries.push(dseriesData)
              }
              if (generate === 1) {
                this[counterAndId[x].show] = true
                this.$nextTick(function () {
                  this.option.title.text = counterAndId[x].title
                  this.option.series = dseries
                  if (counterAndId[x].unit === '%') {
                    this.option.yAxis.min = 0
                    this.option.yAxis.max = 100
                  } else {
                    this.option.yAxis.min = null
                    this.option.yAxis.max = null
                  }
                  this.option.yAxis.axisLabel = {
                    formatter: function (value) {
                      return valueTranUnit(value, 0, counterAndId[x].unit === '%' ? '%' : '')
                    }
                  }
                  this.option.tooltip.formatter = function (params) {
                    let str = '<div>' + params[0].axisValueLabel + '</div>'
                    for (let i = 0; i < params.length; i++) {
                      let value = params[i].data[1]
                      let reValue = valueTranUnit(value, 1, counterAndId[x].unit === '%' ? '%' : '')
                      str += '<div class="circle_tooltip" style="background-color: ' + params[i].color + '"></div>' +
                        '<span>' + params[i].seriesName + '</span> : <span>' + (value !== null ? reValue : '无数据') + '</span><br/>'
                    }
                    return str
                  }
                  let graphLine = echarts.init(document.getElementById(counterAndId[x].id), this.monitorTheme)
                  window.addEventListener('resize', function () {
                    graphLine.resize()
                  })
                  graphLine.clear()
                  graphLine.setOption(this.option, true)
                  graphLine.resize()
                  this[counterAndId[x].intactOptionKey] = graphLine.getOption()
                })
              }
            } else {
              this[counterAndId[x].show] = false
            }
          } else {
            this[counterAndId[x].show] = false
          }
        }).catch(res => {
          if (res.request) {
            console.log(res.request.responseText)
          }
        })
      }
    },
    // 获取即时监控数据
    getCurrentData () {
      if (!this.hostname) {
        return
      }
      let counterAndId = {
        'cpu.user': {
          id: 'cpu_usage_gauge',
          name: 'CPU使用率',
          show: 'cpuUsageGaugeShow',
          type: 'pie'
        },
        'mem.memused.percent': {
          id: 'memory_usage_gauge',
          name: '内存使用率',
          show: 'memoryUsageGaugeShow',
          type: 'pie'
        },
        'df.statistics.used.percent': {
          id: 'disk_usage_gauge',
          name: '磁盘使用率',
          show: 'diskUsageGaugeShow',
          type: 'pie'
        },
        'net.if.in.bytes.total': {
          data: 'netInBytes',
          type: 'data'
        },
        'net.if.out.bytes.total': {
          data: 'netOutBytes',
          type: 'data'
        },
        'disk.io.read_bytes.total': {
          data: 'diskReadBytes',
          type: 'data'
        },
        'disk.io.write_bytes.total': {
          data: 'diskWriteBytes',
          type: 'data'
        }
      }
      let reqParams = {
        hostnames: [this.hostname],
        counters: Object.keys(counterAndId)
      }
      getBaseMonitorOne(reqParams).then(monitorRes => {
        let MonitorDataResult = monitorRes.data
        if (MonitorDataResult.code === 200) {
          if (this.hostname) {
            for (let x in counterAndId) {
              if (counterAndId[x].type === 'pie') {
                if (!MonitorDataResult.data[this.hostname][x] && MonitorDataResult.data[this.hostname][x] !== 0) {
                  this[counterAndId[x].show] = false
                  continue
                }
                this[counterAndId[x].show] = true
                this.$nextTick(function () {
                  this.gaugeOption.series[0].name = counterAndId[x].name
                  this.gaugeOption.series[0].data = [{value: MonitorDataResult.data[this.hostname][x], name: counterAndId[x].name}]
                  let graphLine = echarts.init(document.getElementById(counterAndId[x].id), this.monitorTheme)
                  window.addEventListener('resize', function () {
                    graphLine.resize()
                  })
                  graphLine.clear()
                  graphLine.setOption(this.gaugeOption, true)
                  graphLine.resize()
                })
              } else {
                if (!MonitorDataResult.data[this.hostname][x] && MonitorDataResult.data[this.hostname][x] !== 0) {
                  this[counterAndId[x].data] = 'nodata'
                  continue
                }
                this[counterAndId[x].data] = valueTranUnit(MonitorDataResult.data[this.hostname][x], 0, 'Bytes')
              }
            }
          }
        }
      }).catch(res => {
        if (res.request) {
          console.log(res.request.responseText)
        }
      })
    },
    // 获取磁盘分区使用情况监控数据
    getDiskPartUseData () {
      if (!this.hostname) {
        return
      }
      getDiskPartUseMonitorData({endpoint: this.hostname}).then(res => {
        if (res.data.length) {
          this.diskPartBarShow = true
          this.$nextTick(function () {
            this.diskPartOption.series[0].data = res.data
            let xData = []
            for (let i in res.data) {
              xData.push(res.data[i].name)
            }
            this.diskPartOption.xAxis[0].data = xData
            let graphLine = echarts.init(document.getElementById('disk_part_bar'), this.monitorTheme)
            window.addEventListener('resize', function () {
              graphLine.resize()
            })
            graphLine.clear()
            graphLine.setOption(this.diskPartOption, true)
            graphLine.resize()
          })
        } else {
          this.diskPartBarShow = false
        }
      }).catch(err0 => {
        this.diskPartBarShow = false
      })
    },
    // 获取近期告警数量
    getAlarmOver () {
      if (!this.hostname) {
        return
      }
      let params = {
        endpoints: this.hostname
      }
      getAlarmOverView(params).then(res => {
        if (res.data.code === 200) {
          let recent = res.data.data.recent
          if (recent.status) {
            this.recent_count = recent.count
          } else {
            this.recent_count = 'nodata'
          }
          let problem = res.data.data.problem
          if (problem.status) {
            this.problem_count = problem.count
          } else {
            this.problem_count = 'nodata'
          }
        } else {
          this.recent_count = 'nodata'
          this.problem_count = 'nodata'
        }
      })
    },
    // 定时刷新
    setTimer () {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.getData()
          this.getCurrentData()
          this.getAlarmOver()
          this.getDiskPartUseData()
        }, this.interval * 1000)
      }
    },
    // 定时刷新控制器
    controlMonitorTimer () {
      clearInterval(this.timer)
      this.timer = null
      if (this.autoRefresh) {
        this.setTimer()
      }
    }
  }
}
</script>
<style lang="less">
  #monitor-overview-card .ivu-card-body {
    padding: 5px;
  }
  #monitor-overview {
    background-color: #141214;
  }
  .monitor-overview-back {
    background-color: #1e1c1d
  }
  .charts-legend {
    background-color: #1e1c1d;
    padding-top: 6px;
  }
  #overview-form .ivu-form-item-label {
    color: #30A5D1;
    background-color: #282828;
  }
  #overview-form .ivu-select-selection, #overview-form .ivu-select-dropdown {
    background: #282828;
    border-radius: unset;
    border: none;
    color: #fff
  }
  #overview-form .ivu-select-item {
    color: #fff
  }
  #overview-form .ivu-select-item-selected {
    color: #30A5D1
  }
  #overview-form .ivu-form-item-content {
    height: 30px;
    line-height: 30px;
    padding-left: 2px;
  }
  #overview-form .ivu-select-item-focus, #overview-form .ivu-select-item:hover {
    background: #1E1C1D
  }
  #overview-form .select-server-btn {
    background: #282828;
    color: #fff;
    border: none;
    border-radius: unset;
    height: 32px;
  }
  @media (max-width: 768px) {
    .ivu-div >.ivu-row>div:nth-of-type(1){
     height: auto!important;
     .ivu-row:nth-of-type(1){
       width:48%;
       margin-right:2%;
       display:inline-block;
     }
     .ivu-row:nth-of-type(2){
       width:48%;
       margin-left:2%;
       display:inline-block;
     }
    }
  }
  @media (min-width: 1600px) {
    .ivu-col-span-xxl-16 {
      display: block;
      width: 66.66666667%;
    }
    .ivu-col-span-xxl-14 {
      display: block;
      width: 58.33333333%;
    }
    .ivu-col-span-xxl-13 {
      display: block;
      width: 54.16666667%;
    }
    .ivu-col-span-xxl-11 {
      display: block;
      width: 45.83333333%;
    }
    .ivu-col-span-xxl-10 {
      display: block;
      width: 41.66666667%;
    }
    .ivu-col-span-xxl-8 {
      display: block;
      width: 33.33333333%;
    }
  }
</style>
